 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import BACK00X from '@/components/back00x'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import MM from '@/components/mm'
 import LOVE_1 from '@/components/love_1'
 import TITLE from '@/components/title'
 import TOC from '@/components/toc'
 import CHAP01 from '@/components/chap01'
 import CHAP02 from '@/components/chap02'
 import CHAP03 from '@/components/chap03'
 import CHAP04 from '@/components/chap04'
 import CHAP05 from '@/components/chap05'
 import CHAP06 from '@/components/chap06'
 import CHAP07 from '@/components/chap07'
 import CHAP08 from '@/components/chap08'
 import CHAP09 from '@/components/chap09'
 import CHAP10 from '@/components/chap10'
 import CHAP11 from '@/components/chap11'
 import CHAP12 from '@/components/chap12'
 import CHAP13 from '@/components/chap13'
 import CHAP14 from '@/components/chap14'
 import CHAP15 from '@/components/chap15'
 import CHAP16 from '@/components/chap16'
 import CHAP17 from '@/components/chap17'
 import CHAP18 from '@/components/chap18'
 import CHAP19 from '@/components/chap19'
 import CHAP20 from '@/components/chap20'
 import CHAP21 from '@/components/chap21'
 import CHAP22 from '@/components/chap22'
 import CHAP23 from '@/components/chap23'
 import CHAP24 from '@/components/chap24'
 import CHAP25 from '@/components/chap25'
 import LOVE_2 from '@/components/love_2'
 import BACK01 from '@/components/back01'
 import BACK00 from '@/components/back00'
 import COPYRIGHT from '@/components/copyright'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/back00x",
 			"name" : "back00x",
 			"component" : BACK00X
 		},
 		{
 			"path" : "/ebb",
 			"name" : "ebb",
 			"component" : EBB
 		},
 		{
 			"path" : "/tlu",
 			"name" : "tlu",
 			"component" : TLU
 		},
 		{
 			"path" : "/mm",
 			"name" : "mm",
 			"component" : MM
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/chap01",
 			"name" : "chap01",
 			"component" : CHAP01
 		},
 		{
 			"path" : "/chap02",
 			"name" : "chap02",
 			"component" : CHAP02
 		},
 		{
 			"path" : "/chap03",
 			"name" : "chap03",
 			"component" : CHAP03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js